<template>
  <div id="reports">
    <div class="page-title px-4 mb-4">
      <h2>
        <span class="me-2">Reports</span>
      </h2>
    </div>

    <div>
      <v-row class="mt-1 mb-3" style="align-items: center">
        <v-col cols="5">
          <v-text-field id="startDate" v-model="startDate" label="Start date" outlined hide-details dense type="date" />
        </v-col>
        <v-col cols="5">
          <v-text-field id="endDate" v-model="endDate" label="End date" outlined hide-details dense type="date" />
        </v-col>
        <v-col cols="2">
          <v-btn color="primary" style="min-width: 100%" @click="fetchData">Go</v-btn>
        </v-col>
      </v-row>
    </div>

    <div>
      <v-tabs v-model="currentTab" show-arrows>
        <v-tab v-for="tab in tabs" :key="`${tab.title}-${tab.icon}`">
          <v-icon class="me-3">
            {{ tab.icon }}
          </v-icon>
          <span>
            {{ tab.title }}
          </span>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="currentTab" style="background-color: transparent !important" touchless>
        <!-- OFF ROUTES -->
        <v-tab-item>
          <div v-if="offRoutesLoading" class="fill-height d-flex justify-center align-center py-12">
            <Loader />
          </div>
          <div v-else-if="offRoutes.length">
            <div class="mb-4">
              <v-row>
                <v-col cols="12" md="4">
                  <v-card class="">
                    <v-row class="ma-0 pa-0">
                      <v-col cols="12">
                        <p class="text-center text-no-wrap pt-1 text--xs">Total Off Routes</p>
                        <v-card-text class="text-center pb-2 ps-2 text-xl font-weight-semibold text--primary">
                          <div>
                            {{ offRoutesSummary.totalOffRoutes }}
                          </div>
                        </v-card-text>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card class="">
                    <v-row class="ma-0 pa-0">
                      <v-col cols="12">
                        <p class="text-center text-no-wrap pt-1 text--xs">Number of Vehicles</p>
                        <v-card-text class="text-center pb-2 ps-2 text-xl font-weight-semibold text--primary">
                          <div>
                            {{ offRoutesSummary.totalVehicles }}
                          </div>
                        </v-card-text>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card class="">
                    <v-row class="ma-0 pa-0">
                      <v-col cols="12">
                        <p class="text-center text-no-wrap pt-1 text--xs">Number of Trips</p>
                        <v-card-text class="text-center pb-2 ps-2 text-xl font-weight-semibold text--primary">
                          <div>
                            {{ offRoutesSummary.totalTrips }}
                          </div>
                        </v-card-text>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </div>

            <v-card>
              <div class="px-3">
                <v-row>
                  <v-col cols="12" sm="4">
                    <v-select
                      v-model="offRoutesGroupBy"
                      :items="offRoutesGroupByItems"
                      item-text="text"
                      item-value="value"
                      label="Group by"
                      placeholder="Group by"
                      outlined
                      hide-details
                      clearable
                      multiple
                      dense
                      class="user-search me-3"
                    />
                  </v-col>

                  <v-spacer></v-spacer>

                  <v-col cols="12" sm="4">
                    <v-text-field
                      v-model="offroutesSearch"
                      append-icon=""
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
              </div>

              <div>
                <v-row>
                  <v-col cols="12">
                    <v-data-table
                      :headers="[
                        {
                          text: 'Vehicle ID',
                          value: 'vehicle_id',
                          sortable: true,
                        },
                        {
                          text: 'Route ID',
                          value: 'route_id',
                          sortable: true,
                        },
                        {
                          text: 'Trip ID',
                          value: 'trip_id',
                          sortable: true,
                        },
                        {
                          text: 'Date',
                          value: 'date',
                          sortable: true,
                          filterable: false,
                        },
                        {
                          text: 'Total',
                          value: 'total_offroutes',
                          sortable: true,
                          filterable: false,
                        },
                        {
                          text: 'Avg per trip',
                          value: 'avg_offroutes_per_trip',
                          sortable: true,
                          filterable: false,
                        },
                      ]"
                      :items="offRoutesData"
                      :custom-sort="customSort"
                      :search="offroutesSearch"
                      :sort-by.sync="offroutesSortBy"
                      :sort-desc.sync="offroutesSortDesc"
                      :must-sort="true"
                    >
                      <template v-slot:item="{ item }">
                        <tr>
                          <td>
                            <template v-if="isOffRoutesGroupedByVehicle">
                              <router-link
                                :to="{ name: 'next-stop-vehicle-config', params: { id: item.vehicle_id } }"
                                class="cursor-pointer text-decoration-none font-weight-semibold text--primary"
                              >
                                <v-chip link>{{ item.vehicle_id }}</v-chip>
                              </router-link>
                            </template>
                            <template v-else>
                              {{ item.vehicle_id }}
                            </template>
                          </td>
                          <td>{{ item.route_id }}</td>
                          <td>{{ item.trip_id }}</td>
                          <td>{{ item.date }}</td>
                          <td>{{ item.total_offroutes }}</td>
                          <td>{{ item.avg_offroutes_per_trip }}</td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </div>
            </v-card>
          </div>

          <div v-else>
            <span class="font-weight-semibold text--primary"> No off routes data available </span>
          </div>
        </v-tab-item>
        <!-- END OFF ROUTES -->

        <!-- TRIP ASSIGNMENTS -->
        <v-tab-item>
          <div v-if="tripsLoading" class="fill-height d-flex justify-center align-center py-12">
            <Loader />
          </div>
          <div v-else-if="trips.length">
            <div class="mb-4">
              <v-row>
                <v-col cols="12" md="4">
                  <v-card class="">
                    <v-row class="ma-0 pa-0">
                      <v-col cols="12">
                        <p class="text-center text-no-wrap pt-1 text--xs">
                          Total Trips Assigned<span v-if="tripAssignmentsHasTagFilter"> (Selected Tags)</span>
                        </p>
                        <v-card-text class="text-center pb-2 ps-2 text-xl font-weight-semibold text--primary">
                          <div>
                            {{ tripsSummary.taggedTripsAssigned }}
                          </div>
                          <div v-if="tripAssignmentsHasTagFilter" class="text-xs font-weight-regular text--secondary">
                            All: {{ tripsSummary.totalTripsAssigned }} ({{
                              formatRate(tripsSummary.taggedTripsAssigned, tripsSummary.totalTripsAssigned)
                            }}
                            selected)
                          </div>
                        </v-card-text>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card class="">
                    <v-row class="ma-0 pa-0">
                      <v-col cols="12">
                        <p class="text-center text-no-wrap pt-1 text--xs">
                          Total Trips Confirmed<span v-if="tripAssignmentsHasTagFilter"> (Selected Tags)</span>
                        </p>
                        <v-card-text class="text-center pb-2 ps-2 text-xl font-weight-semibold text--primary">
                          <div>
                            {{ tripsSummary.taggedTripsConfirmed }} ({{
                              formatRate(tripsSummary.taggedTripsConfirmed, tripsSummary.taggedTripsAssigned)
                            }})
                          </div>
                          <div v-if="tripAssignmentsHasTagFilter" class="text-xs font-weight-regular text--secondary">
                            All: {{ tripsSummary.totalTripsConfirmed }} ({{
                              formatRate(tripsSummary.totalTripsConfirmed, tripsSummary.totalTripsAssigned)
                            }})
                          </div>
                        </v-card-text>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card class="">
                    <v-row class="ma-0 pa-0">
                      <v-col cols="12">
                        <p class="text-center text-no-wrap pt-1 text--xs">
                          Total Mismatched Trips<span v-if="tripAssignmentsHasTagFilter"> (Selected Tags)</span>
                        </p>
                        <v-card-text class="text-center pb-2 ps-2 text-xl font-weight-semibold text--primary">
                          <div>
                            {{ tripsSummary.taggedMismatched }} ({{
                              formatRate(tripsSummary.taggedMismatched, tripsSummary.taggedTripsAssigned)
                            }})
                          </div>
                          <div v-if="tripAssignmentsHasTagFilter" class="text-xs font-weight-regular text--secondary">
                            All: {{ tripsSummary.totalMismatched }} ({{
                              formatRate(tripsSummary.totalMismatched, tripsSummary.totalTripsAssigned)
                            }})
                          </div>
                        </v-card-text>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </div>

            <v-expansion-panels v-if="tripAssignmentsTagBreakdown.length" flat class="mb-6">
              <v-expansion-panel>
                <v-expansion-panel-header class="text-sm font-weight-semibold text--primary">
                  View tag-based trip breakdown
                </v-expansion-panel-header>

                <v-expansion-panel-content>
                  <p class="text-xs text--secondary mb-2">
                    A trip is counted under every tag it carries, so tag rows overlap and will not sum to the All Trips
                    totals.
                  </p>

                  <v-data-table
                    :headers="[
                      {
                        text: 'Tag',
                        value: 'tag',
                        sortable: true,
                      },
                      {
                        text: 'Tag Type',
                        value: 'tag_type',
                        sortable: true,
                      },
                      {
                        text: 'Trips Assigned',
                        value: 'total_assigned',
                        sortable: true,
                      },
                      {
                        text: 'Trips Confirmed',
                        value: 'total_confirmed',
                        sortable: true,
                      },
                      {
                        text: 'Trips Missed',
                        value: 'total_missed',
                        sortable: true,
                      },
                    ]"
                    :items="tripAssignmentsTagBreakdown"
                    :sort-by.sync="tripAssignmentsTagBreakdownSortBy"
                    :sort-desc.sync="tripAssignmentsTagBreakdownSortDesc"
                    :items-per-page="-1"
                    :must-sort="true"
                    hide-default-footer
                    dense
                  >
                    <template v-slot:item.tag="{ item }">
                      <v-chip small color="secondary" outlined>{{ item.tag }}</v-chip>
                    </template>
                    <template v-slot:item.total_confirmed="{ item }">
                      {{ item.total_confirmed }} ({{ formatRate(item.total_confirmed, item.total_assigned) }})
                    </template>
                    <template v-slot:item.total_missed="{ item }">
                      {{ item.total_missed }} ({{ formatRate(item.total_missed, item.total_assigned) }})
                    </template>
                    <template v-slot:body.append>
                      <tr class="font-weight-semibold text--primary">
                        <td>All Trips</td>
                        <td>&mdash;</td>
                        <td>{{ tripsSummary.totalTripsAssigned }}</td>
                        <td>
                          {{ tripsSummary.totalTripsConfirmed }} ({{
                            formatRate(tripsSummary.totalTripsConfirmed, tripsSummary.totalTripsAssigned)
                          }})
                        </td>
                        <td>
                          {{ tripsSummary.totalMismatched }} ({{
                            formatRate(tripsSummary.totalMismatched, tripsSummary.totalTripsAssigned)
                          }})
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

            <v-card>
              <div class="px-3">
                <v-row>
                  <v-col cols="12" sm="4">
                    <v-select
                      v-model="tripAssignmentsGroupBy"
                      :items="tripAssignmentsGroupByItems"
                      item-text="text"
                      item-value="value"
                      label="Group by"
                      placeholder="Group by"
                      outlined
                      hide-details
                      clearable
                      multiple
                      dense
                      class="user-search me-3"
                    />
                  </v-col>

                  <v-col cols="12" sm="4">
                    <v-select
                      v-model="tripAssignmentsTags"
                      :items="tripAssignmentsTagOptions"
                      item-text="text"
                      item-value="value"
                      label="Tags"
                      placeholder="Tags"
                      outlined
                      hide-details
                      clearable
                      multiple
                      chips
                      small-chips
                      deletable-chips
                      dense
                      class="user-search me-3"
                    />
                  </v-col>

                  <v-col cols="12" sm="4">
                    <v-text-field
                      v-model="tripAssignmentsSearch"
                      append-icon=""
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
              </div>

              <div>
                <v-row>
                  <v-col cols="12">
                    <v-data-table
                      :headers="[
                        {
                          text: 'Vehicle ID',
                          value: 'vehicle_id',
                          sortable: true,
                        },
                        {
                          text: 'Vehicle Tags',
                          value: 'tags',
                          sortable: false,
                        },
                        {
                          text: 'Device Tags',
                          value: 'device_tags',
                          sortable: false,
                        },
                        {
                          text: 'Open Notes',
                          value: 'open_notes_count',
                          sortable: true,
                          filterable: false,
                        },
                        {
                          text: 'Trips Assigned',
                          value: 'total_assigned',
                          sortable: true,
                          filterable: false,
                        },
                        {
                          text: 'Trips Confirmed',
                          value: 'total_confirmed',
                          sortable: true,
                          filterable: false,
                        },
                        {
                          text: 'Trips Mismatch',
                          value: 'total_mismatch',
                          sortable: true,
                          filterable: false,
                        },
                        {
                          text: 'Date',
                          value: 'date',
                          sortable: true,
                          filterable: false,
                        },
                      ]"
                      :items="tripsData"
                      :custom-sort="customSort"
                      :search="tripAssignmentsSearch"
                      :sort-by.sync="tripAssignmentsSortBy"
                      :sort-desc.sync="tripAssignmentsSortDesc"
                      :must-sort="true"
                    >
                      <template v-slot:item.vehicle_id="{ item }">
                        <template v-if="istripAssignmentsGroupedByVehicle">
                          <router-link
                            :to="{ name: 'next-stop-vehicle-config', params: { id: item.vehicle_id } }"
                            class="cursor-pointer text-decoration-none font-weight-semibold text--primary"
                          >
                            <v-chip link>{{ item.vehicle_id }}</v-chip>
                          </router-link>
                        </template>
                        <template v-else>
                          {{ item.vehicle_id }}
                        </template>
                      </template>
                      <template v-slot:item.tags="{ item }">
                        <TagChips :tags="item.tags" />
                      </template>
                      <template v-slot:item.device_tags="{ item }">
                        <TagChips :tags="item.device_tags" :new-ssd-date="item.new_ssd_date" />
                      </template>
                      <template v-slot:item.open_notes_count="{ item }">
                        <router-link
                          v-if="item.open_notes_count > 0"
                          :to="{
                            name: 'next-stop-notes',
                            query: { sqVehicleId: item.vehicle_id, sqStatus: noteOpenStatuses },
                          }"
                          class="cursor-pointer text-decoration-none font-weight-semibold text--primary"
                        >
                          <v-chip link small>
                            {{ item.open_notes_count }}
                          </v-chip>
                        </router-link>
                        <span v-else>{{ item.open_notes_count }}</span>
                      </template>
                      <template v-slot:item.total_assigned="{ item }">
                        {{ item.total_assigned }}
                      </template>
                      <template v-slot:item.total_confirmed="{ item }">
                        {{ item.total_confirmed }}
                      </template>
                      <template v-slot:item.total_mismatch="{ item }">
                        {{ item.total_mismatch }} ({{ formatPercentage(item.total_mismatch_percentage) }})
                      </template>
                      <template v-slot:item.date="{ item }">
                        {{ item.date }}
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </div>
            </v-card>
          </div>

          <div v-else>
            <span class="font-weight-semibold text--primary"> No trips data available </span>
          </div>
        </v-tab-item>
        <!-- END TRIP ASSIGNMENTS -->

        <!-- NETWORK USAGE -->
        <v-tab-item>
          <div v-if="networkUsageLoading" class="fill-height d-flex justify-center align-center py-12">
            <Loader />
          </div>
          <div v-else-if="networkUsage.length">
            <div class="mb-4">
              <v-row>
                <v-col cols="4">
                  <v-card class="">
                    <v-row class="ma-0 pa-0">
                      <v-col cols="12">
                        <p class="text-center text-no-wrap pt-1 text--xs">Total Upload</p>
                        <v-card-text class="text-center pb-2 ps-2 text-xl font-weight-semibold text--primary">
                          <div>
                            {{ networkUsageSummary.totalUpload }}
                          </div>
                        </v-card-text>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>

                <v-col cols="4">
                  <v-card class="">
                    <v-row class="ma-0 pa-0">
                      <v-col cols="12">
                        <p class="text-center text-no-wrap pt-1 text--xs">Total Download</p>
                        <v-card-text class="text-center pb-2 ps-2 text-xl font-weight-semibold text--primary">
                          <div>
                            {{ networkUsageSummary.totalDownload }}
                          </div>
                        </v-card-text>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>

                <v-col cols="4">
                  <v-card class="">
                    <v-row class="ma-0 pa-0">
                      <v-col cols="12">
                        <p class="text-center text-no-wrap pt-1 text--xs">Total Usage</p>
                        <v-card-text class="text-center pb-2 ps-2 text-xl font-weight-semibold text--primary">
                          <div>
                            {{ networkUsageSummary.totalUsage }}
                          </div>
                        </v-card-text>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </div>

            <v-card>
              <div class="px-3">
                <v-row>
                  <v-col cols="12" sm="4">
                    <v-select
                      v-model="networkGroupBy"
                      :items="networkGroupByItems"
                      item-text="text"
                      item-value="value"
                      label="Group by"
                      placeholder="Group by"
                      outlined
                      hide-details
                      clearable
                      multiple
                      dense
                      class="user-search me-3"
                    />
                  </v-col>

                  <v-spacer></v-spacer>

                  <v-col cols="12" sm="4">
                    <v-text-field
                      v-model="networkSearch"
                      append-icon=""
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
              </div>

              <div v-if="showNetworkColour()" class="px-3">
                <v-row>
                  <v-col cols="12">
                    <p class="text--primary font-weight-medium">
                      Highlighting devices with daily total usage over
                      <v-chip color="error">{{ networkUsageAlertMB }} MB</v-chip> and
                      <v-chip color="warning">{{ networkUsageWarningMB }} MB</v-chip>
                    </p>
                  </v-col>
                </v-row>
              </div>

              <div>
                <v-row>
                  <v-col cols="12">
                    <v-data-table
                      :headers="[
                        {
                          text: 'Device ID',
                          value: 'device_id',
                          sortable: true,
                        },
                        {
                          text: 'Vehicle ID',
                          value: 'vehicle_id',
                          sortable: true,
                        },
                        {
                          text: 'Upload',
                          value: 'upload',
                          sortable: true,
                          filterable: false,
                        },
                        {
                          text: 'Download',
                          value: 'download',
                          sortable: true,
                          filterable: false,
                        },
                        {
                          text: 'Total Usage',
                          value: 'total_usage',
                          sortable: true,
                          filterable: false,
                        },
                        {
                          text: 'Date',
                          value: 'date',
                          sortable: true,
                          filterable: false,
                        },
                      ]"
                      :items="networkUsageData"
                      :custom-sort="customSort"
                      :search="networkSearch"
                      :sort-by.sync="networkSortBy"
                      :sort-desc.sync="networkSortDesc"
                      :must-sort="true"
                    >
                      <template v-slot:item="{ item }">
                        <tr>
                          <td>
                            <router-link
                              :to="{ name: 'next-stop-device-config', params: { id: item.device_id } }"
                              class="cursor-pointer text-decoration-none font-weight-semibold text--primary"
                              >{{ item.device_id }}
                            </router-link>
                          </td>
                          <td>
                            <router-link
                              :to="{ name: 'next-stop-vehicle-config', params: { id: item.vehicle_id } }"
                              class="cursor-pointer text-decoration-none font-weight-semibold text--primary"
                              >{{ item.vehicle_id }}
                            </router-link>
                          </td>
                          <td>{{ item.upload }}</td>
                          <td>{{ item.download }}</td>
                          <td>
                            <v-chip :color="getNetworkColour(item.total_bytes)">{{ item.total_usage }}</v-chip>
                          </td>
                          <td>{{ item.date }}</td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </div>
            </v-card>
          </div>

          <div v-else>
            <span class="font-weight-semibold text--primary"> No network usage data available </span>
          </div>
        </v-tab-item>
        <!-- END NETWORK USAGE -->

        <!-- TRIP REPORTS -->
        <v-tab-item>
          <div v-if="tripReportsLoading" class="fill-height d-flex justify-center align-center py-12">
            <Loader />
          </div>
          <div v-else-if="tripReports.length">
            <div class="mb-4">
              <v-row>
                <v-col cols="12" md="4">
                  <v-card class="">
                    <v-row class="ma-0 pa-0">
                      <v-col cols="12">
                        <p class="text-center text-no-wrap pt-1 text--xs">Total Trip Reports</p>
                        <v-card-text class="text-center pb-2 ps-2 text-xl font-weight-semibold text--primary">
                          <div>
                            {{ tripReportsSummary.totalTripReports }}
                          </div>
                        </v-card-text>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card class="">
                    <v-row class="ma-0 pa-0">
                      <v-col cols="12">
                        <p class="text-center text-no-wrap pt-1 text--xs">Unique Vehicles</p>
                        <v-card-text class="text-center pb-2 ps-2 text-xl font-weight-semibold text--primary">
                          <div>
                            {{ tripReportsSummary.totalVehicles }}
                          </div>
                        </v-card-text>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card class="">
                    <v-row class="ma-0 pa-0">
                      <v-col cols="12">
                        <p class="text-center text-no-wrap pt-1 text--xs">Avg. Stops Announced %</p>
                        <v-card-text class="text-center pb-2 ps-2 text-xl font-weight-semibold text--primary">
                          <div>
                            {{ formatPercentage(tripReportsSummary.totalStopsAnnouncedPercentage) }}
                          </div>
                        </v-card-text>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </div>

            <v-card>
              <div class="px-3">
                <v-row>
                  <v-col cols="12" sm="4">
                    <v-select
                      v-model="tripReportsGroupBy"
                      :items="tripReportsGroupByItems"
                      item-text="text"
                      item-value="value"
                      label="Group by"
                      placeholder="Group by"
                      outlined
                      hide-details
                      clearable
                      multiple
                      dense
                      class="user-search me-3"
                    />
                  </v-col>

                  <v-spacer></v-spacer>

                  <v-col cols="12" sm="4">
                    <v-text-field
                      v-model="tripReportsSearch"
                      append-icon=""
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
              </div>
              <div>
                <v-row>
                  <v-col cols="12">
                    <v-data-table
                      :headers="[
                        {
                          text: 'Vehicle ID',
                          value: 'vehicle_id',
                          sortable: true,
                        },
                        {
                          text: 'Route ID',
                          value: 'route_id',
                          sortable: true,
                        },
                        {
                          text: 'Trip ID',
                          value: 'trip_id',
                          sortable: true,
                        },
                        {
                          text: 'Stops Expected',
                          value: 'stops_expected',
                          sortable: true,
                        },
                        {
                          text: 'Stops Announced',
                          value: 'stops_announced',
                          sortable: true,
                        },
                        {
                          text: 'Stops Missed',
                          value: 'stops_missed',
                          sortable: true,
                        },
                        {
                          text: 'Announced %',
                          value: 'stops_announced_percentage',
                          sortable: true,
                        },
                        {
                          text: 'Trip Start Datetime',
                          value: 'start_datetime',
                          sortable: true,
                          filterable: false,
                        },
                        {
                          text: 'Trip End Datetime',
                          value: 'end_datetime',
                          sortable: true,
                          filterable: false,
                        },
                        {
                          text: 'Trip Date',
                          value: 'date',
                          sortable: true,
                          filterable: false,
                        },
                        {
                          text: 'Actions',
                          value: 'actions',
                          sortable: false,
                        },
                      ]"
                      :items="tripReportsData"
                      :custom-sort="customSort"
                      :sort-by.sync="tripReportsSortBy"
                      :sort-desc.sync="tripReportsSortDesc"
                      :must-sort="true"
                      :search="tripReportsSearch"
                    >
                      <template v-slot:item.vehicle_id="{ item }">
                        <tr>
                          <td>
                            <router-link
                              :to="{ name: 'next-stop-vehicle-config', params: { id: item.vehicle_id } }"
                              class="cursor-pointer text-decoration-none font-weight-semibold text--primary"
                              >{{ item.vehicle_id }}
                            </router-link>
                          </td>
                        </tr>
                      </template>
                      <template v-slot:item.actions="{ item }">
                        <v-btn
                          v-if="item.event_id && (!tripReportsGroupBy || !tripReportsGroupBy.length)"
                          icon
                          small
                          color="primary"
                          @click="openMapDialog(item)"
                        >
                          <v-icon>{{ icons.mdiMapSearch }}</v-icon>
                        </v-btn>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </div>
            </v-card>
          </div>

          <div v-else>
            <span class="font-weight-semibold text--primary"> No trip reports data available </span>
          </div>
        </v-tab-item>
        <!-- END TRIP REPORTS -->

        <!-- DEVICE REBOOTS -->
        <v-tab-item>
          <div v-if="deviceRebootsLoading" class="fill-height d-flex justify-center align-center py-12">
            <Loader />
          </div>
          <div v-else-if="deviceReboots.length">
            <div class="mb-4">
              <v-row>
                <v-col cols="12" md="4">
                  <v-card>
                    <v-row class="ma-0 pa-0">
                      <v-col cols="12">
                        <p class="text-center text-no-wrap pt-1 text--xs">Total Reboots</p>
                        <v-card-text class="text-center pb-2 ps-2 text-xl font-weight-semibold text--primary">
                          <div>{{ deviceRebootsSummary.totalReboots }}</div>
                        </v-card-text>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card>
                    <v-row class="ma-0 pa-0">
                      <v-col cols="12">
                        <p class="text-center text-no-wrap pt-1 text--xs">Number of Devices</p>
                        <v-card-text class="text-center pb-2 ps-2 text-xl font-weight-semibold text--primary">
                          <div>{{ deviceRebootsSummary.totalDevices }}</div>
                        </v-card-text>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card>
                    <v-row class="ma-0 pa-0">
                      <v-col cols="12">
                        <p class="text-center text-no-wrap pt-1 text--xs">Number of Vehicles</p>
                        <v-card-text class="text-center pb-2 ps-2 text-xl font-weight-semibold text--primary">
                          <div>{{ deviceRebootsSummary.totalVehicles }}</div>
                        </v-card-text>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </div>

            <v-card>
              <div class="px-3">
                <v-row>
                  <v-col cols="12" sm="4">
                    <v-select
                      v-model="deviceRebootsGroupBy"
                      :items="deviceRebootsGroupByItems"
                      item-text="text"
                      item-value="value"
                      label="Group by"
                      placeholder="Group by"
                      outlined
                      hide-details
                      clearable
                      multiple
                      dense
                      class="user-search me-3"
                    />
                  </v-col>

                  <v-spacer></v-spacer>

                  <v-col cols="12" sm="4">
                    <v-text-field
                      v-model="deviceRebootsSearch"
                      append-icon=""
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
              </div>

              <div>
                <v-row>
                  <v-col cols="12">
                    <v-data-table
                      :headers="[
                        { text: 'Device ID', value: 'device_id', sortable: true },
                        { text: 'Vehicle ID', value: 'vehicle_id', sortable: true },
                        { text: 'Device Tags', value: 'device_tags', sortable: false },
                        { text: 'Vehicle Tags', value: 'vehicle_tags', sortable: false },
                        { text: 'Reboots', value: 'total_reboots', sortable: true, filterable: false },
                        { text: 'Date', value: 'date', sortable: true, filterable: false },
                      ]"
                      :items="deviceRebootsData"
                      :custom-sort="customSort"
                      :search="deviceRebootsSearch"
                      :sort-by.sync="deviceRebootsSortBy"
                      :sort-desc.sync="deviceRebootsSortDesc"
                      :must-sort="true"
                    >
                      <template v-slot:item.device_id="{ item }">
                        <template v-if="isDeviceRebootsGroupedByDevice && item.device_id && item.device_id !== '-'">
                          <router-link
                            :to="{ name: 'next-stop-device-config', params: { id: item.device_id } }"
                            class="cursor-pointer text-decoration-none font-weight-semibold text--primary"
                          >
                            <v-chip link>{{ item.device_id }}</v-chip>
                          </router-link>
                        </template>
                        <template v-else>{{ item.device_id }}</template>
                      </template>

                      <template v-slot:item.vehicle_id="{ item }">
                        <template v-if="isDeviceRebootsGroupedByVehicle && item.vehicle_id && item.vehicle_id !== '-'">
                          <router-link
                            :to="{ name: 'next-stop-vehicle-config', params: { id: item.vehicle_id } }"
                            class="cursor-pointer text-decoration-none font-weight-semibold text--primary"
                          >
                            <v-chip link>{{ item.vehicle_id }}</v-chip>
                          </router-link>
                        </template>
                        <template v-else>{{ item.vehicle_id }}</template>
                      </template>

                      <template v-slot:item.device_tags="{ item }">
                        <TagChips :tags="item.device_tags" :new-ssd-date="item.new_ssd_date" />
                      </template>

                      <template v-slot:item.vehicle_tags="{ item }">
                        <TagChips :tags="item.vehicle_tags" />
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </div>
            </v-card>
          </div>

          <div v-else>
            <span class="font-weight-semibold text--primary"> No device reboots data available </span>
          </div>
        </v-tab-item>
        <!-- END DEVICE REBOOTS -->

        <!-- DEVICE LOCATION CHANGES -->
        <v-tab-item>
          <div v-if="deviceLocationChangesLoading" class="fill-height d-flex justify-center align-center py-12">
            <Loader />
          </div>
          <div v-else-if="deviceLocationChanges.length">
            <div class="mb-4">
              <v-row>
                <v-col cols="12" md="4">
                  <v-card>
                    <v-row class="ma-0 pa-0">
                      <v-col cols="12">
                        <p class="text-center text-no-wrap pt-1 text--xs">Total Transfers</p>
                        <v-card-text class="text-center pb-2 ps-2 text-xl font-weight-semibold text--primary">
                          <div>{{ deviceLocationChangesSummary.totalChanges }}</div>
                        </v-card-text>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card>
                    <v-row class="ma-0 pa-0">
                      <v-col cols="12">
                        <p class="text-center text-no-wrap pt-1 text--xs">Number of Cases</p>
                        <v-card-text class="text-center pb-2 ps-2 text-xl font-weight-semibold text--primary">
                          <div>{{ deviceLocationChangesSummary.totalCases }}</div>
                        </v-card-text>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card>
                    <v-row class="ma-0 pa-0">
                      <v-col cols="12">
                        <p class="text-center text-no-wrap pt-1 text--xs">Number of Vehicles</p>
                        <v-card-text class="text-center pb-2 ps-2 text-xl font-weight-semibold text--primary">
                          <div>{{ deviceLocationChangesSummary.totalVehicles }}</div>
                        </v-card-text>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </div>

            <v-card>
              <div class="px-3">
                <v-row>
                  <v-col cols="12" sm="4">
                    <v-select
                      v-model="deviceLocationChangesGroupBy"
                      :items="deviceLocationChangesGroupByItems"
                      item-text="text"
                      item-value="value"
                      label="Group by"
                      placeholder="Group by"
                      outlined
                      hide-details
                      clearable
                      multiple
                      dense
                      class="user-search me-3"
                    />
                  </v-col>

                  <v-spacer></v-spacer>

                  <v-col cols="12" sm="4">
                    <v-text-field
                      v-model="deviceLocationChangesSearch"
                      append-icon=""
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
              </div>

              <div>
                <v-row>
                  <v-col cols="12">
                    <v-data-table
                      :headers="deviceLocationChangesHeaders"
                      :items="deviceLocationChangesData"
                      :custom-sort="customSort"
                      :search="deviceLocationChangesSearch"
                      :sort-by.sync="deviceLocationChangesSortBy"
                      :sort-desc.sync="deviceLocationChangesSortDesc"
                      :must-sort="true"
                    >
                      <template v-slot:item.vehicle_id="{ item }">
                        <template
                          v-if="isDeviceLocationChangesGroupedByVehicle && item.vehicle_id && item.vehicle_id !== '-'"
                        >
                          <router-link
                            :to="{ name: 'next-stop-vehicle-config', params: { id: item.vehicle_id } }"
                            class="cursor-pointer text-decoration-none font-weight-semibold text--primary"
                          >
                            <v-chip link>{{ item.vehicle_id }}</v-chip>
                          </router-link>
                        </template>
                        <template v-else>{{ item.vehicle_id }}</template>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </div>
            </v-card>
          </div>

          <div v-else>
            <span class="font-weight-semibold text--primary"> No device transfers data available </span>
          </div>
        </v-tab-item>
        <!-- END DEVICE LOCATION CHANGES -->

        <!-- PROBLEM VEHICLES -->
        <v-tab-item>
          <div v-if="problemVehiclesLoading" class="fill-height d-flex justify-center align-center py-12">
            <Loader />
          </div>
          <div v-else-if="problemVehiclesData.length">
            <div class="mb-4">
              <v-row>
                <v-col cols="12" md="4">
                  <v-card class="">
                    <v-row class="ma-0 pa-0">
                      <v-col cols="12">
                        <p class="text-center text-no-wrap pt-1 text--xs">Problem Vehicles</p>
                        <v-card-text class="text-center pb-2 ps-2 text-xl font-weight-semibold text--primary">
                          <div>
                            {{ problemVehiclesSummary.totalVehicles }}
                          </div>
                        </v-card-text>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card class="">
                    <v-row class="ma-0 pa-0">
                      <v-col cols="12">
                        <p class="text-center text-no-wrap pt-1 text--xs">Trips Missed</p>
                        <v-card-text class="text-center pb-2 ps-2 text-xl font-weight-semibold text--primary">
                          <div>
                            {{ problemVehiclesSummary.totalMissedTrips }}
                          </div>
                        </v-card-text>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card class="">
                    <v-row class="ma-0 pa-0">
                      <v-col cols="12">
                        <p class="text-center text-no-wrap pt-1 text--xs">Longest Outage</p>
                        <v-card-text class="text-center pb-2 ps-2 text-xl font-weight-semibold text--primary">
                          <div>
                            {{ problemVehiclesSummary.longestOutage }}
                          </div>
                        </v-card-text>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </div>

            <v-card>
              <div>
                <v-row class="pt-4 pb-0 ma-0">
                  <v-col cols="12" sm="4">
                    <v-text-field
                      v-model="problemVehiclesSearch"
                      append-icon=""
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
              </div>

              <div>
                <v-row>
                  <v-col cols="12">
                    <v-data-table
                      :headers="[
                        { text: 'Vehicle ID', value: 'vehicle_id', sortable: true },
                        { text: 'Device ID', value: 'device_id', sortable: true },
                        { text: 'Device Tags', value: 'device_tags', sortable: false, filterable: false },
                        { text: 'Last Online', value: 'last_online', sortable: true, filterable: false },
                        { text: 'Offline For', value: 'offline_minutes', sortable: true, filterable: false },
                        { text: 'Offline Reason', value: 'offline_reason', sortable: true },
                        { text: 'Trips Missed', value: 'missed_trips', sortable: true, filterable: false },
                        {
                          text: 'SSD Remaining Life (%)',
                          value: 'ssd_remaining_life_pct',
                          sortable: true,
                          filterable: false,
                        },
                        { text: 'SSD Sampled', value: 'ssd_sampled', sortable: true, filterable: false },
                        { text: 'Open Notes', value: 'open_notes_count', sortable: true, filterable: false },
                      ]"
                      :items="problemVehiclesData"
                      :search="problemVehiclesSearch"
                      :sort-by.sync="problemVehiclesSortBy"
                      :sort-desc.sync="problemVehiclesSortDesc"
                      :must-sort="true"
                    >
                      <template v-slot:item.vehicle_id="{ item }">
                        <router-link
                          :to="{ name: 'next-stop-vehicle-config', params: { id: item.vehicle_id } }"
                          class="cursor-pointer text-decoration-none font-weight-semibold text--primary"
                        >
                          <v-chip link>{{ item.vehicle_id }}</v-chip>
                        </router-link>
                      </template>
                      <template v-slot:item.device_id="{ item }">
                        <router-link
                          :to="{ name: 'next-stop-device-config', params: { id: item.device_id } }"
                          class="cursor-pointer text-decoration-none font-weight-semibold text--primary"
                        >
                          <v-chip link small>{{ item.device_id }}</v-chip>
                        </router-link>
                      </template>
                      <template v-slot:item.device_tags="{ item }">
                        <TagChips :tags="item.device_tags" :new-ssd-date="item.new_ssd_date" />
                      </template>
                      <template v-slot:item.last_online="{ item }">
                        <span class="text-no-wrap">{{ item.last_online }}</span>
                      </template>
                      <template v-slot:item.offline_minutes="{ item }">
                        <span class="text-no-wrap error--text font-weight-semibold">
                          {{ formatOfflineDuration(item.offline_minutes) }}
                        </span>
                      </template>
                      <template v-slot:item.offline_reason="{ item }">
                        <div class="d-flex flex-column">
                          <span>{{ item.offline_reason || "-" }}</span>
                          <span v-if="item.services_not_running.length" class="text-xs text--secondary">
                            Not running: {{ item.services_not_running.join(", ") }}
                          </span>
                        </div>
                      </template>
                      <template v-slot:item.missed_trips="{ item }">
                        <span class="font-weight-semibold">{{ item.missed_trips }}</span>
                        <span v-if="item.missed_trips_capped" class="text-xs text--secondary ms-1"> (60d+) </span>
                      </template>
                      <template v-slot:item.ssd_remaining_life_pct="{ item }">
                        {{ item.ssd_remaining_life_pct === null ? "-" : item.ssd_remaining_life_pct }}
                      </template>
                      <template v-slot:item.ssd_sampled="{ item }">
                        <span class="text-no-wrap">{{ item.ssd_sampled || "-" }}</span>
                      </template>
                      <template v-slot:item.open_notes_count="{ item }">
                        <router-link
                          v-if="item.open_notes_count > 0"
                          :to="{
                            name: 'next-stop-notes',
                            query: { sqVehicleId: item.vehicle_id, sqStatus: noteOpenStatuses },
                          }"
                          class="cursor-pointer text-decoration-none font-weight-semibold text--primary"
                        >
                          <v-chip link small>
                            {{ item.open_notes_count }}
                          </v-chip>
                        </router-link>
                        <span v-else>{{ item.open_notes_count }}</span>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </div>
            </v-card>
          </div>

          <div v-else>
            <span class="font-weight-semibold text--primary">
              No vehicles are currently offline with missed trips
            </span>
          </div>
        </v-tab-item>
        <!-- END PROBLEM VEHICLES -->
      </v-tabs-items>
    </div>

    <v-dialog v-model="mapDialog" max-width="1200px" @click:outside="closeMapDialog">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center">
          <span>Trip Report Map</span>
          <v-btn icon @click="closeMapDialog">
            <v-icon>{{ icons.mdiClose }}</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <div v-if="isMapLoading" class="d-flex justify-center align-center py-12">
            <Loader />
          </div>
          <VehicleGPSHistoryMap v-else :gpsData="selectedTripGpsData" :dataByEventId="selectedTripDataByEventId" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  mdiTimelineRemove,
  mdiWan,
  mdiBusClock,
  mdiMapSearch,
  mdiClose,
  mdiTransitConnectionVariant,
  mdiRestart,
  mdiSwapHorizontal,
  mdiBusAlert,
} from "@mdi/js"
import { mapState } from "vuex"
import byteSize from "byte-size"
import axios from "axios"

import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"
import timezone from "dayjs/plugin/timezone"
import Loader from "@/components/Loader.vue"
import store from "@/store"
import { getConfigTags, getNewSsdDate, isNewSsdTag } from "@/utils/tags"
import TagChips from "@/views/next-stop/components/TagChips.vue"
import VehicleGPSHistoryMap from "../../next-stop/vehicles/components/VehicleGPSHistoryMap.vue"

dayjs.extend(utc)
dayjs.extend(timezone)

// Vehicle and device tags share one filter dropdown, so their values are
// prefixed to keep a tag of the same name on each apart
const VEHICLE_TAG_PREFIX = "vehicle:"
const DEVICE_TAG_PREFIX = "device:"

export default {
  name: "Reports",
  metaInfo: {
    title: "Reports",
  },
  components: {
    Loader,
    TagChips,
    VehicleGPSHistoryMap,
  },
  setup() {
    return {
      icons: {
        mdiMapSearch,
        mdiClose,
      },
    }
  },
  data() {
    return {
      noteOpenStatuses: ["Open", "Pending", "On Hold"],
      currentTab: 0,
      tabs: [
        {
          title: "Off Routes",
          icon: mdiTimelineRemove,
        },
        {
          title: "Trip Assignments",
          icon: mdiBusClock,
        },
        {
          title: "Network usage",
          icon: mdiWan,
        },
        {
          title: "Trip Reports",
          icon: mdiTransitConnectionVariant,
        },
        {
          title: "Device Reboots",
          icon: mdiRestart,
        },
        {
          title: "Device Transfers",
          icon: mdiSwapHorizontal,
        },
        {
          title: "Problem Vehicles",
          icon: mdiBusAlert,
        },
      ],
      startDate: dayjs.tz(new Date(), "Pacific/Auckland").subtract(1, "day").format("YYYY-MM-DD"),
      endDate: dayjs.tz(new Date(), "Pacific/Auckland").subtract(1, "day").format("YYYY-MM-DD"),
      offRoutes: [],
      networkUsage: [],
      trips: [],
      tripReports: [],
      notes: [],
      offRoutesLoading: false,
      networkUsageLoading: false,
      tripsLoading: false,
      tripReportsLoading: false,
      offRoutesGroupBy: null,
      offRoutesGroupByItems: [
        {
          text: "Vehicle",
          value: "vehicle_id",
        },
        {
          text: "Route",
          value: "route_id",
        },
        {
          text: "Trip",
          value: "trip_id",
        },
        {
          text: "Date",
          value: "date",
        },
      ],
      tripAssignmentsGroupBy: null,
      tripAssignmentsGroupByItems: [
        {
          text: "Vehicle",
          value: "vehicle_id",
        },
        {
          text: "Date",
          value: "date",
        },
      ],
      networkGroupBy: null,
      networkGroupByItems: [
        {
          text: "Device",
          value: "device_id",
        },
        {
          text: "Date",
          value: "date",
        },
      ],
      tripReportsGroupBy: null,
      tripReportsGroupByItems: [
        {
          text: "Vehicle",
          value: "vehicle_id",
        },
        {
          text: "Route",
          value: "route_id",
        },
        {
          text: "Trip",
          value: "trip_id",
        },
        {
          text: "Date",
          value: "date",
        },
      ],
      deviceReboots: [],
      deviceRebootsLoading: false,
      deviceRebootsGroupBy: null,
      deviceRebootsGroupByItems: [
        {
          text: "Device",
          value: "device_id",
        },
        {
          text: "Vehicle",
          value: "vehicle_id",
        },
        {
          text: "Date",
          value: "date",
        },
      ],
      deviceRebootsSortBy: "total_reboots",
      deviceRebootsSortDesc: true,
      deviceRebootsSearch: "",
      deviceLocationChanges: [],
      deviceLocationChangesLoading: false,
      deviceLocationChangesGroupBy: null,
      deviceLocationChangesGroupByItems: [
        {
          text: "Hardware",
          value: "case_id",
        },
        {
          text: "Sender",
          value: "sender_organisation",
        },
        {
          text: "Receiver",
          value: "receiving_organisation",
        },
        {
          text: "Vehicle",
          value: "vehicle_id",
        },
      ],
      deviceLocationChangesSortBy: "created",
      deviceLocationChangesSortDesc: true,
      deviceLocationChangesSearch: "",
      offRoutesRequest: axios.CancelToken.source(),
      networkUsageRequest: axios.CancelToken.source(),
      tripsRequest: axios.CancelToken.source(),
      tripReportsRequest: axios.CancelToken.source(),
      deviceRebootsRequest: axios.CancelToken.source(),
      deviceLocationChangesRequest: axios.CancelToken.source(),
      networkUsageAlertMB: 300, // 300MB
      networkUsageAlert: 300 * 1000 * 1000, // 300MB
      networkUsageWarningMB: 200, // 200MB
      networkUsageWarning: 200 * 1000 * 1000, // 200MB
      networkSortBy: "total_usage",
      networkSortDesc: true, // true for descending order, false for ascending order
      networkSearch: "",
      offroutesSortBy: "total_offroutes",
      offroutesSortDesc: true, // true for descending order, false for ascending order
      offroutesSearch: "",
      tripAssignmentsSortBy: "total_mismatch",
      tripAssignmentsSortDesc: true,
      tripAssignmentsSearch: "",
      tripAssignmentsTags: [],
      tripAssignmentsTagBreakdownSortBy: "total_missed",
      tripAssignmentsTagBreakdownSortDesc: true,
      tripReportsSortBy: "start_datetime",
      tripReportsSortDesc: false,
      tripReportsSearch: "",
      mapDialog: false,
      isMapLoading: false,
      selectedTripDataByEventId: [],
      selectedTripGpsData: [],
      eventsRequest: axios.CancelToken.source(),
      gpsRequest: null,
      gpsProgress: {
        total: 0,
        current: 0,
        percentage: 0,
        finished: true,
      },
      fetchedDateKey: {
        offRoutes: null,
        networkUsage: null,
        trips: null,
        tripReports: null,
        deviceReboots: null,
        deviceLocationChanges: null,
        problemVehicles: null,
      },
      problemVehicleTrips: [],
      problemVehiclesLoading: false,
      problemVehiclesSearch: "",
      problemVehiclesSortBy: "missed_trips",
      problemVehiclesSortDesc: true,
    }
  },
  computed: {
    currentDateKey() {
      return `${this.startDate}|${this.endDate}`
    },
    activeReportKey() {
      const keys = [
        "offRoutes",
        "trips",
        "networkUsage",
        "tripReports",
        "deviceReboots",
        "deviceLocationChanges",
        "problemVehicles",
      ]

      return keys[this.currentTab] ?? null
    },
    ...mapState({
      vehicles: state => state.gtfs.vehicles,
      devices: state => state.gtfs.devices,
      allNotes: state => state.gtfs.notes,
    }),
    openNotesByVehicle() {
      const noteCounts = new Map()

      if (this.allNotes) {
        this.allNotes.forEach(note => {
          if (note.vehicle_id && note.status !== "Closed") {
            const currentCount = noteCounts.get(note.vehicle_id) || 0
            noteCounts.set(note.vehicle_id, currentCount + 1)
          }
        })
      }

      return noteCounts
    },
    // Devices that are offline and still assigned to a vehicle, which is what
    // makes them a problem vehicle rather than just a spare device on a shelf
    offlineVehicleDevices() {
      return (this.devices || []).filter(
        device =>
          device.config?.vehicle_id && device.status?.status === "offline" && this.lastOnlineMs(device) !== null,
      )
    },

    // This report deliberately ignores the page's date pickers and always looks
    // back a fixed 60 days, so an outage is visible whatever the dates above are
    // set to. Being fixed also means it does not wait on the device list, which
    // previously left the report with no trips to count when devices arrived
    // after the tab was opened. Vehicles offline longer than the window are
    // flagged, since their count is then a floor rather than a total.
    problemVehiclesWindow() {
      const now = dayjs.tz(new Date(), "Pacific/Auckland")
      const start = now.subtract(60, "day").startOf("day")

      return {
        startDate: start.format("YYYY-MM-DD 00:00:00"),
        endDate: now.format("YYYY-MM-DD 23:59:59"),
        capMs: start.valueOf(),
        key: `${start.format("YYYY-MM-DD")}|${now.format("YYYY-MM-DD")}`,
      }
    },

    // Missed trips per vehicle per day, counted exactly as the Trip Assignments
    // report counts them, so the two reports agree on the same vehicle
    problemVehiclesMissedByVehicle() {
      const byVehicle = new Map()

      ;(this.problemVehicleTrips || []).forEach(item => {
        if (!item.vehicle_id) {
          return
        }

        if (!byVehicle.has(item.vehicle_id)) {
          byVehicle.set(item.vehicle_id, [])
        }

        byVehicle.get(item.vehicle_id).push({
          // Kept as a YYYY-MM-DD string and compared as text, which orders
          // correctly without a parse that could quietly produce NaN and drop
          // every row from the count
          day: String(item.date).slice(0, 10),
          missed: Math.abs((item.total_assigned || 0) - (item.total_confirmed || 0)),
        })
      })

      return byVehicle
    },

    problemVehiclesData() {
      const { capMs } = this.problemVehiclesWindow
      const now = Date.now()

      return (
        this.offlineVehicleDevices
          .map(device => {
            const vehicleId = device.config.vehicle_id
            const lastOnline = this.lastOnlineMs(device)

            // Only trips from the day it dropped off onwards count as missed
            const fromDay = dayjs.tz(lastOnline, "Pacific/Auckland").format("YYYY-MM-DD")
            const missedTrips = (this.problemVehiclesMissedByVehicle.get(vehicleId) || [])
              .filter(entry => entry.day >= fromDay)
              .reduce((total, entry) => total + entry.missed, 0)

            return {
              vehicle_id: vehicleId,
              device_id: device.device_id,
              device_tags: getConfigTags(device.config),
              new_ssd_date: getNewSsdDate(device.config) || "",
              last_online: dayjs.tz(lastOnline, "Pacific/Auckland").format("YYYY-MM-DD HH:mm"),
              offline_minutes: Math.max(Math.floor((now - lastOnline) / 60000), 0),
              offline_reason: device.status?.is_reachable?.reason || "",
              services_not_running: device.status?.services_not_running || [],
              missed_trips: missedTrips,
              // Trips before the cap were never fetched, so this is a floor
              missed_trips_capped: lastOnline < capMs,
              ssd_remaining_life_pct: device.ssd?.remaining_life_pct ?? null,
              ssd_sampled: device.ssd?.sample_datetime || "",
              open_notes_count: this.openNotesByVehicle.get(vehicleId) || 0,
            }
          })
          // The report is about outages that cost trips, so a device that is
          // offline without having missed anything is not a problem vehicle. Trips
          // are only counted from the day it dropped off and the device is still
          // offline now, so anything left here went offline, stayed offline, and
          // missed trips while it was down.
          .filter(row => row.missed_trips > 0)
      )
    },

    problemVehiclesSummary() {
      const rows = this.problemVehiclesData

      return {
        totalVehicles: rows.length,
        totalMissedTrips: rows.reduce((total, row) => total + row.missed_trips, 0),
        longestOutage: rows.length
          ? this.formatOfflineDuration(Math.max(...rows.map(row => row.offline_minutes)))
          : "-",
      }
    },

    offRoutesSummary() {
      if (!this.offRoutes.length) {
        return {
          totalOffRoutes: 0,
          totalVehicles: 0,
          totalTrips: 0,
        }
      }

      let total = 0
      const trips = []
      const vehicles = []

      this.offRoutes.forEach(item => {
        total += item.total

        if (!trips.includes(item.trip_id)) {
          trips.push(item.trip_id)
        }

        if (!vehicles.includes(item.vehicle_id)) {
          vehicles.push(item.vehicle_id)
        }
      })

      return {
        totalOffRoutes: total,
        totalVehicles: vehicles.length,
        totalTrips: trips.length,
      }
    },
    isOffRoutesGroupedByVehicle() {
      return !this.offRoutesGroupBy || !this.offRoutesGroupBy.length || this.offRoutesGroupBy.includes("vehicle_id")
    },
    offRoutesData() {
      if (!this.offRoutes.length) {
        return []
      }

      const rows = []
      const hasGroupBy = this.offRoutesGroupBy && this.offRoutesGroupBy.length > 0

      // Helper to create a group key for identifying rows
      const getGroupKey = (item, formattedDate) => {
        if (hasGroupBy) {
          return this.offRoutesGroupBy
            .map(group => {
              if (group === "vehicle_id") return item.vehicle_id
              if (group === "trip_id") return item.trip_id
              if (group === "route_id") return item.route_id
              if (group === "date") return formattedDate

              return ""
            })
            .join("|")
        }

        return [item.vehicle_id, item.trip_id, item.route_id, formattedDate].join("|")
      }

      const rowMap = new Map() // groupKey -> row
      const groupSets = new Map() // groupKey -> { vehicles, trips, routes, dates }

      this.offRoutes.forEach(item => {
        const formattedDate = dayjs.tz(item.date, "Pacific/Auckland").format("YYYY-MM-DD")
        const [route_id] = item.trip_id.split("__")
        item.route_id = route_id

        const groupKey = getGroupKey(item, formattedDate)

        if (!groupSets.has(groupKey)) {
          groupSets.set(groupKey, {
            vehicles: new Set(),
            trips: new Set(),
            routes: new Set(),
            dates: new Set(),
          })
        }

        const group = groupSets.get(groupKey)
        group.vehicles.add(item.vehicle_id)
        group.trips.add(item.trip_id)
        group.routes.add(item.route_id)
        group.dates.add(formattedDate)

        if (!rowMap.has(groupKey)) {
          rowMap.set(groupKey, {
            vehicle_id: item.vehicle_id,
            trip_id: item.trip_id,
            route_id: item.route_id,
            date: formattedDate,
            total_offroutes: item.total,
            trip_count: 1,
          })
        } else {
          const row = rowMap.get(groupKey)
          row.total_offroutes += item.total
          row.trip_count += 1
        }
      })

      groupSets.forEach((sets, groupKey) => {
        const row = rowMap.get(groupKey)

        const resultRow = {
          vehicle_id:
            !hasGroupBy || this.offRoutesGroupBy.includes("vehicle_id")
              ? row.vehicle_id
              : `${sets.vehicles.size} vehicles`,
          trip_id: !hasGroupBy || this.offRoutesGroupBy.includes("trip_id") ? row.trip_id : `${sets.trips.size} trips`,
          route_id:
            !hasGroupBy || this.offRoutesGroupBy.includes("route_id") ? row.route_id : `${sets.routes.size} routes`,
          date: !hasGroupBy || this.offRoutesGroupBy.includes("date") ? row.date : `${sets.dates.size} dates`,
          total_offroutes: row.total_offroutes,
        }

        if (sets.trips.size > 1) {
          resultRow.avg_offroutes_per_trip = +(row.total_offroutes / sets.trips.size).toFixed(1)
        } else {
          resultRow.avg_offroutes_per_trip = row.total_offroutes
        }

        rows.push(resultRow)
      })

      return rows
    },
    networkUsageSummary() {
      if (!this.networkUsage.length) {
        return {
          totalUpload: 0,
          totalDownload: 0,
          totalUsage: 0,
        }
      }

      let totalUpload = 0
      let totalDownload = 0

      this.networkUsage.forEach(item => {
        totalUpload += item.upload
        totalDownload += item.download
      })

      return {
        totalUpload: byteSize(totalUpload).toString(),
        totalDownload: byteSize(totalDownload).toString(),
        totalUsage: byteSize(totalDownload + totalUpload).toString(),
      }
    },
    networkUsageData() {
      if (!this.networkUsage.length) {
        return []
      }

      const rows = []
      const hasGroupBy = this.networkGroupBy && this.networkGroupBy.length > 0

      this.networkUsage.forEach(item => {
        const formattedDate = dayjs.tz(item.date, "Pacific/Auckland").format("YYYY-MM-DD")

        let rowIndex

        if (hasGroupBy) {
          rowIndex = rows.findIndex(r =>
            this.networkGroupBy.every(group => {
              if (group === "device_id") {
                return r.device_id === item.device_id
              }
              if (group === "date") {
                return r.date === formattedDate
              }

              return false
            }),
          )
        } else {
          rowIndex = rows.findIndex(r => r.device_id === item.device_id && r.date === formattedDate)
        }

        if (rowIndex === -1) {
          const row = {
            device_id: !hasGroupBy || this.networkGroupBy?.includes("device_id") ? item.device_id : "-",
            vehicle_id: !hasGroupBy || this.networkGroupBy?.includes("device_id") ? item.vehicle_id : "-",
            upload: item.upload,
            download: item.download,
            total: item.download + item.upload,
            date: !hasGroupBy || this.networkGroupBy?.includes("date") ? formattedDate : "-",
          }

          rows.push(row)
        } else {
          rows[rowIndex].upload += item.upload
          rows[rowIndex].download += item.download
          rows[rowIndex].total += item.upload + item.download
        }
      })

      // Add in byte size formatting
      const formattedRows = rows.map(item => ({
        device_id: item.device_id,
        vehicle_id: item.vehicle_id,
        upload: byteSize(item.upload).toString(),
        upload_bytes: item.upload,
        download: byteSize(item.download).toString(),
        download_bytes: item.download,
        total_usage: byteSize(item.total).toString(),
        total_bytes: item.total,
        date: item.date,
      }))

      return formattedRows
    },
    // Vehicle tags keyed by vehicle id
    tripAssignmentsVehicleTagsMap() {
      const vehicleTagsMap = new Map()
      this.vehicles.forEach(vehicle => {
        vehicleTagsMap.set(vehicle.vehicle_id, getConfigTags(vehicle.config))
      })

      return vehicleTagsMap
    },
    // Tags of the device assigned to each vehicle, keyed by vehicle id
    tripAssignmentsDeviceTagsMap() {
      const deviceTagsByVehicleMap = new Map()
      this.devices.forEach(device => {
        const vehicleId = device.config?.vehicle_id
        if (vehicleId) {
          deviceTagsByVehicleMap.set(vehicleId, getConfigTags(device.config))
        }
      })

      return deviceTagsByVehicleMap
    },
    // The day each vehicle's device was given the New SSD tag, keyed by vehicle
    // id. Vehicles without the tag, or with it but no created date, are absent.
    tripAssignmentsNewSsdDateMap() {
      const newSsdDateMap = new Map()
      this.devices.forEach(device => {
        const vehicleId = device.config?.vehicle_id
        const newSsdDate = vehicleId ? getNewSsdDate(device.config) : ""

        if (newSsdDate) {
          newSsdDateMap.set(vehicleId, newSsdDate)
        }
      })

      return newSsdDateMap
    },
    // Trip totals per individual tag, for comparison against the overall
    // totals. Deliberately ignores the tag filter, since this is the baseline
    // the filtered figures are compared against.
    tripAssignmentsTagBreakdown() {
      const tagsByVehicle = new Map()
      const tagsFor = vehicleId => {
        if (!tagsByVehicle.has(vehicleId)) {
          tagsByVehicle.set(vehicleId, {
            vehicle: this.tripAssignmentsVehicleTagsMap.get(vehicleId) || [],
            device: this.tripAssignmentsDeviceTagsMap.get(vehicleId) || [],
          })
        }

        return tagsByVehicle.get(vehicleId)
      }

      const rowsByTag = new Map()
      const addTrip = (tagType, tag, item) => {
        const key = `${tagType}|${tag}`

        if (!rowsByTag.has(key)) {
          rowsByTag.set(key, {
            tag,
            tag_type: tagType,
            total_assigned: 0,
            total_confirmed: 0,
            total_missed: 0,
          })
        }

        const row = rowsByTag.get(key)
        row.total_assigned += item.total_assigned
        row.total_confirmed += item.total_confirmed
        row.total_missed += Math.abs(item.total_assigned - item.total_confirmed)
      }

      this.trips.forEach(item => {
        const tags = tagsFor(item.vehicle_id)

        tags.vehicle.forEach(tag => addTrip("Vehicle", tag, item))
        tags.device.forEach(tag => {
          // New SSD only owns the trips that ran after the drive went in
          if (isNewSsdTag(tag) && !this.isTripAfterNewSsd(item)) {
            return
          }

          addTrip("Device", tag, item)
        })
      })

      return [...rowsByTag.values()].sort((a, b) => a.tag.localeCompare(b.tag))
    },
    // The tags present in the current trips data, as a single list of select
    // items grouped under a subheading per tag type
    tripAssignmentsTagOptions() {
      const toItems = (tagType, header, prefix) => {
        const items = this.tripAssignmentsTagBreakdown
          .filter(row => row.tag_type === tagType)
          .map(row => ({ text: row.tag, value: `${prefix}${row.tag}` }))

        return items.length ? [{ header }, ...items] : []
      }

      const vehicleItems = toItems("Vehicle", "Vehicle Tags", VEHICLE_TAG_PREFIX)
      const deviceItems = toItems("Device", "Device Tags", DEVICE_TAG_PREFIX)

      if (vehicleItems.length && deviceItems.length) {
        return [...vehicleItems, { divider: true }, ...deviceItems]
      }

      return [...vehicleItems, ...deviceItems]
    },
    tripAssignmentsHasTagFilter() {
      return this.tripAssignmentsTags.length > 0
    },
    // The selected tags split back out by the type of tag they came from
    tripAssignmentsSelectedTags() {
      const vehicle = []
      const device = []

      this.tripAssignmentsTags.forEach(value => {
        if (value.startsWith(VEHICLE_TAG_PREFIX)) {
          vehicle.push(value.slice(VEHICLE_TAG_PREFIX.length))
        } else if (value.startsWith(DEVICE_TAG_PREFIX)) {
          device.push(value.slice(DEVICE_TAG_PREFIX.length))
        }
      })

      return { vehicle, device }
    },
    // Vehicles carrying every selected tag: all of the selected vehicle tags on
    // the vehicle, and all of the selected device tags on the device assigned to
    // it. Null when no tag filter is applied, meaning every vehicle is included.
    tripAssignmentsTaggedVehicleIds() {
      if (!this.tripAssignmentsHasTagFilter) {
        return null
      }

      const selected = this.tripAssignmentsSelectedTags
      const matchesAll = (tags, selectedTags) => selectedTags.every(tag => (tags || []).includes(tag))

      const vehicleIds = new Set([
        ...this.tripAssignmentsVehicleTagsMap.keys(),
        ...this.tripAssignmentsDeviceTagsMap.keys(),
      ])

      const matched = new Set()
      vehicleIds.forEach(vehicleId => {
        if (
          matchesAll(this.tripAssignmentsVehicleTagsMap.get(vehicleId), selected.vehicle) &&
          matchesAll(this.tripAssignmentsDeviceTagsMap.get(vehicleId), selected.device)
        ) {
          matched.add(vehicleId)
        }
      })

      return matched
    },
    tripsSummary() {
      const taggedVehicleIds = this.tripAssignmentsTaggedVehicleIds

      const summary = {
        totalTripsAssigned: 0,
        totalTripsConfirmed: 0,
        totalMismatched: 0,
        taggedTripsAssigned: 0,
        taggedTripsConfirmed: 0,
        taggedMismatched: 0,
      }

      this.trips.forEach(item => {
        const mismatched = Math.abs(item.total_assigned - item.total_confirmed)

        summary.totalTripsAssigned += item.total_assigned
        summary.totalTripsConfirmed += item.total_confirmed
        summary.totalMismatched += mismatched

        if (this.isTripInTagSelection(item, taggedVehicleIds)) {
          summary.taggedTripsAssigned += item.total_assigned
          summary.taggedTripsConfirmed += item.total_confirmed
          summary.taggedMismatched += mismatched
        }
      })

      return summary
    },
    istripAssignmentsGroupedByVehicle() {
      return (
        !this.tripAssignmentsGroupBy ||
        !this.tripAssignmentsGroupBy.length ||
        this.tripAssignmentsGroupBy.includes("vehicle_id")
      )
    },
    tripsData() {
      if (!this.trips.length) {
        return []
      }

      const rows = []
      const hasGroupBy = this.tripAssignmentsGroupBy && this.tripAssignmentsGroupBy.length > 0
      const taggedVehicleIds = this.tripAssignmentsTaggedVehicleIds

      const getGroupKey = (item, formattedDate) => {
        if (hasGroupBy) {
          return this.tripAssignmentsGroupBy
            .map(group => {
              if (group === "vehicle_id") return item.vehicle_id
              if (group === "date") return formattedDate

              return ""
            })
            .join("|")
        }

        return [item.vehicle_id, formattedDate].join("|")
      }

      const rowMap = new Map() // groupKey -> row
      const groupSets = new Map() // groupKey -> { vehicles, dates }

      this.trips.forEach(item => {
        if (!this.isTripInTagSelection(item, taggedVehicleIds)) {
          return
        }

        const formattedDate = dayjs.tz(item.date, "Pacific/Auckland").format("YYYY-MM-DD")
        const groupKey = getGroupKey(item, formattedDate)

        if (!groupSets.has(groupKey)) {
          groupSets.set(groupKey, {
            vehicles: new Set(),
            dates: new Set(),
          })
        }

        const group = groupSets.get(groupKey)
        group.vehicles.add(item.vehicle_id)
        group.dates.add(formattedDate)

        if (!rowMap.has(groupKey)) {
          rowMap.set(groupKey, {
            vehicle_id: item.vehicle_id,
            date: formattedDate,
            total_assigned: item.total_assigned,
            total_confirmed: item.total_confirmed,
          })
        } else {
          const row = rowMap.get(groupKey)
          row.total_assigned += item.total_assigned
          row.total_confirmed += item.total_confirmed
        }
      })

      // A row only carries tags when it is a single vehicle's trips, since tags
      // belong to the vehicle rather than to any of the other groupings
      const isPerVehicle = !hasGroupBy || this.tripAssignmentsGroupBy.includes("vehicle_id")

      groupSets.forEach((sets, groupKey) => {
        const row = rowMap.get(groupKey)
        const total_mismatch = Math.abs(row.total_assigned - row.total_confirmed)
        const mismatch_percent = row.total_assigned === 0 ? 0 : total_mismatch / row.total_assigned

        // Retrieve open notes count
        const openNotesCount = this.openNotesByVehicle.get(row.vehicle_id) || 0

        // The last day of trips in this row, which is what decides whether the
        // New SSD tag was in place for any of them
        const latestDate = [...sets.dates].sort().pop()

        rows.push({
          vehicle_id: isPerVehicle ? row.vehicle_id : `${sets.vehicles.size} vehicles`,
          date: !hasGroupBy || this.tripAssignmentsGroupBy.includes("date") ? row.date : `${sets.dates.size} dates`,
          total_assigned: row.total_assigned,
          total_confirmed: row.total_confirmed,
          total_mismatch: total_mismatch,
          total_mismatch_percentage: mismatch_percent,
          open_notes_count: openNotesCount,

          // Tags come from the pre-built maps for efficiency
          tags: isPerVehicle ? this.tripAssignmentsVehicleTagsMap.get(row.vehicle_id) || [] : [],
          device_tags: isPerVehicle ? this.deviceTagsForTrips(row.vehicle_id, latestDate) : [],
          new_ssd_date: isPerVehicle ? this.tripAssignmentsNewSsdDateMap.get(row.vehicle_id) || "" : "",
        })
      })

      return rows
    },
    tripReportsSummary() {
      if (!this.tripReports.length) {
        return {
          totalTripReports: 0,
          totalVehicles: 0,
          totalStopsAnnouncedPercentage: 0,
        }
      }

      const vehicles = []
      let totalStopsExpected = 0
      let totalStopsAnnounced = 0

      this.tripReports.forEach(item => {
        if (!vehicles.includes(item.event_data.vehicle_id)) {
          vehicles.push(item.event_data.vehicle_id)
        }

        totalStopsExpected += item.event_data.stops_expected || 0
        totalStopsAnnounced += item.event_data.stops_announced || 0
      })

      // Calculate the average stops announced percentage
      const averageStopsPercentage = totalStopsExpected > 0 ? totalStopsAnnounced / totalStopsExpected : 1

      return {
        totalTripReports: this.tripReports.length,
        totalVehicles: vehicles.length,
        totalStopsAnnouncedPercentage: averageStopsPercentage,
      }
    },
    tripReportsData() {
      if (!this.tripReports.length) {
        return []
      }

      const rows = []
      const hasGroupBy = this.tripReportsGroupBy && this.tripReportsGroupBy.length > 0

      this.tripReports.forEach(item => {
        const formattedDate = dayjs.unix(item.event_data.start_timestamp).tz("Pacific/Auckland").format("YYYY-MM-DD")

        const [route_id] = item.event_data.trip_id.split("__")
        item.event_data.route_id = route_id

        // Format some data first
        item.event_data.start_datetime = dayjs
          .unix(item.event_data.start_timestamp)
          .tz("Pacific/Auckland")
          .format("YYYY-MM-DD HH:mm")

        item.event_data.end_datetime = dayjs
          .unix(item.event_data.end_timestamp)
          .tz("Pacific/Auckland")
          .format("YYYY-MM-DD HH:mm")

        item.event_data.stops_announced_percentage = item.event_data.stops_expected
          ? item.event_data.stops_announced / item.event_data.stops_expected
          : 1

        // Group if required
        let rowIndex

        if (hasGroupBy) {
          rowIndex = rows.findIndex(r =>
            this.tripReportsGroupBy.every(group => {
              if (group === "vehicle_id") {
                return r.vehicle_id === item.event_data.vehicle_id
              }
              if (group === "date") {
                return r.date === formattedDate
              }
              if (group === "route_id") {
                return r.route_id === item.event_data.route_id
              }
              if (group === "trip_id") {
                return decodeURIComponent(r.trip_id) === decodeURIComponent(item.event_data.trip_id)
              }

              return false
            }),
          )
        } else {
          rowIndex = rows.findIndex(
            r =>
              decodeURIComponent(r.trip_id) === decodeURIComponent(item.event_data.trip_id) &&
              r.route_id === item.event_data.route_id &&
              r.vehicle_id === item.event_data.vehicle_id &&
              r.date === formattedDate &&
              r.start_datetime === item.event_data.start_datetime,
          )
        }

        if (rowIndex === -1) {
          const row = {
            vehicle_id:
              !hasGroupBy || this.tripReportsGroupBy?.includes("vehicle_id") ? item.event_data.vehicle_id : "-",
            trip_id: !hasGroupBy || this.tripReportsGroupBy?.includes("trip_id") ? item.event_data.trip_id : "-",
            route_id: !hasGroupBy || this.tripReportsGroupBy?.includes("route_id") ? item.event_data.route_id : "-",
            stops_expected: item.event_data.stops_expected,
            stops_announced: item.event_data.stops_announced,
            stops_missed: item.event_data.stops_missed,
            stops_announced_percentage: this.formatPercentage(item.event_data.stops_announced_percentage),
            start_datetime: item.event_data.start_datetime,
            end_datetime: item.event_data.end_datetime,
            date: !hasGroupBy || this.tripReportsGroupBy?.includes("date") ? formattedDate : "-",
            event_id: item.event_data.id,
          }

          rows.push(row)
        } else {
          // rows[rowIndex].stops_expected += item.event_data.stops_expected
          rows[rowIndex].stops_announced += item.event_data.stops_announced
          rows[rowIndex].stops_missed += item.event_data.stops_missed

          const averageStopsPercentage = rows[rowIndex].stops_expected
            ? rows[rowIndex].stops_announced / rows[rowIndex].stops_expected
            : 1
          rows[rowIndex].stops_announced_percentage = this.formatPercentage(averageStopsPercentage)
        }
      })

      return rows
    },
    isDeviceRebootsGroupedByDevice() {
      return (
        !this.deviceRebootsGroupBy ||
        !this.deviceRebootsGroupBy.length ||
        this.deviceRebootsGroupBy.includes("device_id")
      )
    },
    isDeviceRebootsGroupedByVehicle() {
      return (
        !this.deviceRebootsGroupBy ||
        !this.deviceRebootsGroupBy.length ||
        this.deviceRebootsGroupBy.includes("vehicle_id")
      )
    },
    deviceRebootsSummary() {
      if (!this.deviceReboots.length) {
        return {
          totalReboots: 0,
          totalDevices: 0,
          totalVehicles: 0,
        }
      }

      const devices = []
      const vehicles = []

      this.deviceReboots.forEach(item => {
        const deviceId = item.event_data.device_id
        const device = this.devices.find(d => d.device_id === deviceId)
        const vehicleId = device?.config?.vehicle_id

        if (deviceId && !devices.includes(deviceId)) {
          devices.push(deviceId)
        }

        if (vehicleId && !vehicles.includes(vehicleId)) {
          vehicles.push(vehicleId)
        }
      })

      return {
        totalReboots: this.deviceReboots.length,
        totalDevices: devices.length,
        totalVehicles: vehicles.length,
      }
    },
    deviceRebootsData() {
      if (!this.deviceReboots.length) {
        return []
      }

      const rows = []
      const hasGroupBy = this.deviceRebootsGroupBy && this.deviceRebootsGroupBy.length > 0

      // Create maps for efficient device → vehicle id and tag lookups
      const deviceVehicleMap = new Map()
      const deviceTagsMap = new Map()
      const deviceNewSsdDateMap = new Map()
      this.devices.forEach(device => {
        deviceVehicleMap.set(device.device_id, device.config?.vehicle_id || "")
        deviceTagsMap.set(device.device_id, getConfigTags(device.config))
        deviceNewSsdDateMap.set(device.device_id, getNewSsdDate(device.config))
      })

      const vehicleTagsMap = new Map()
      this.vehicles.forEach(vehicle => {
        vehicleTagsMap.set(vehicle.vehicle_id, getConfigTags(vehicle.config))
      })

      const getGroupKey = (item, formattedDate) => {
        const deviceId = item.event_data.device_id
        const vehicleId = deviceVehicleMap.get(deviceId) || ""

        if (hasGroupBy) {
          return this.deviceRebootsGroupBy
            .map(group => {
              if (group === "device_id") return deviceId
              if (group === "vehicle_id") return vehicleId
              if (group === "date") return formattedDate

              return ""
            })
            .join("|")
        }

        return [deviceId, vehicleId, formattedDate].join("|")
      }

      const rowMap = new Map() // groupKey -> row
      const groupSets = new Map() // groupKey -> { devices, vehicles, dates }

      this.deviceReboots.forEach(item => {
        const formattedDate = dayjs.tz(item.event_data.date_time, "Pacific/Auckland").format("YYYY-MM-DD")
        const deviceId = item.event_data.device_id
        const vehicleId = deviceVehicleMap.get(deviceId) || ""
        const groupKey = getGroupKey(item, formattedDate)

        if (!groupSets.has(groupKey)) {
          groupSets.set(groupKey, {
            devices: new Set(),
            vehicles: new Set(),
            dates: new Set(),
          })
        }

        const group = groupSets.get(groupKey)
        group.devices.add(deviceId)
        group.vehicles.add(vehicleId)
        group.dates.add(formattedDate)

        if (!rowMap.has(groupKey)) {
          rowMap.set(groupKey, {
            device_id: deviceId,
            vehicle_id: vehicleId,
            date: formattedDate,
            total_reboots: 1,
          })
        } else {
          const row = rowMap.get(groupKey)
          row.total_reboots += 1
        }
      })

      groupSets.forEach((sets, groupKey) => {
        const row = rowMap.get(groupKey)

        rows.push({
          device_id:
            !hasGroupBy || this.deviceRebootsGroupBy.includes("device_id")
              ? row.device_id
              : `${sets.devices.size} devices`,
          vehicle_id:
            !hasGroupBy || this.deviceRebootsGroupBy.includes("vehicle_id")
              ? row.vehicle_id
              : `${sets.vehicles.size} vehicles`,
          date: !hasGroupBy || this.deviceRebootsGroupBy.includes("date") ? row.date : `${sets.dates.size} dates`,
          total_reboots: row.total_reboots,
        })
      })

      // Add tags using the pre-built maps for efficiency
      return rows.map(reboot => ({
        ...reboot,
        device_tags: deviceTagsMap.get(reboot.device_id) || [],
        vehicle_tags: vehicleTagsMap.get(reboot.vehicle_id) || [],
        new_ssd_date: deviceNewSsdDateMap.get(reboot.device_id) || "",
      }))
    },
    deviceLocationChangesSummary() {
      if (!this.deviceLocationChanges.length) {
        return {
          totalChanges: 0,
          totalCases: 0,
          totalVehicles: 0,
        }
      }

      const cases = new Set()
      const vehicles = new Set()

      this.deviceLocationChanges.forEach(item => {
        if (item.case_id) cases.add(item.case_id)
        if (item.vehicle_id) vehicles.add(item.vehicle_id)
      })

      return {
        totalChanges: this.deviceLocationChanges.length,
        totalCases: cases.size,
        totalVehicles: vehicles.size,
      }
    },
    deviceLocationChangesHeaders() {
      const hasGroupBy = this.deviceLocationChangesGroupBy && this.deviceLocationChangesGroupBy.length > 0

      if (hasGroupBy) {
        return [
          { text: "Hardware ID", value: "case_id", sortable: true },
          { text: "Sender", value: "sender_organisation", sortable: true },
          { text: "Receiver", value: "receiving_organisation", sortable: true },
          { text: "Vehicle ID", value: "vehicle_id", sortable: true },
          { text: "Total Transfers", value: "total_changes", sortable: true, filterable: false },
        ]
      }

      return [
        { text: "Hardware ID", value: "case_id", sortable: true },
        { text: "Sender", value: "sender_organisation", sortable: true },
        { text: "Receiver", value: "receiving_organisation", sortable: true },
        { text: "Vehicle ID", value: "vehicle_id", sortable: true },
        { text: "Location Status", value: "location_status", sortable: true },
        { text: "Transfer Status", value: "transfer_status", sortable: true },
        { text: "User", value: "user", sortable: true },
        { text: "Created", value: "created", sortable: true, filterable: false },
      ]
    },
    isDeviceLocationChangesGroupedByVehicle() {
      return (
        !this.deviceLocationChangesGroupBy ||
        !this.deviceLocationChangesGroupBy.length ||
        this.deviceLocationChangesGroupBy.includes("vehicle_id")
      )
    },
    deviceLocationChangesData() {
      if (!this.deviceLocationChanges.length) {
        return []
      }

      const hasGroupBy = this.deviceLocationChangesGroupBy && this.deviceLocationChangesGroupBy.length > 0

      if (!hasGroupBy) {
        return this.deviceLocationChanges.map(item => ({
          case_id: item.case_id,
          sender_organisation: item.sender_organisation,
          receiving_organisation: item.receiving_organisation,
          vehicle_id: item.vehicle_id,
          location_status: item.location_status,
          transfer_status: item.transfer_status,
          user: item.user,
          created: item.created ? dayjs.tz(item.created, "Pacific/Auckland").format("YYYY-MM-DD HH:mm:ss") : "",
        }))
      }

      const rowMap = new Map()
      const groupSets = new Map()

      const getGroupKey = item =>
        this.deviceLocationChangesGroupBy
          .map(group => {
            if (group === "case_id") return item.case_id ?? ""
            if (group === "sender_organisation") return item.sender_organisation ?? ""
            if (group === "receiving_organisation") return item.receiving_organisation ?? ""
            if (group === "vehicle_id") return item.vehicle_id ?? ""

            return ""
          })
          .join("|")

      this.deviceLocationChanges.forEach(item => {
        const groupKey = getGroupKey(item)

        if (!groupSets.has(groupKey)) {
          groupSets.set(groupKey, {
            cases: new Set(),
            senders: new Set(),
            receivers: new Set(),
            vehicles: new Set(),
          })
        }

        const sets = groupSets.get(groupKey)
        if (item.case_id) sets.cases.add(item.case_id)
        if (item.sender_organisation) sets.senders.add(item.sender_organisation)
        if (item.receiving_organisation) sets.receivers.add(item.receiving_organisation)
        if (item.vehicle_id) sets.vehicles.add(item.vehicle_id)

        if (!rowMap.has(groupKey)) {
          rowMap.set(groupKey, {
            case_id: item.case_id,
            sender_organisation: item.sender_organisation,
            receiving_organisation: item.receiving_organisation,
            vehicle_id: item.vehicle_id,
            total_changes: 1,
          })
        } else {
          rowMap.get(groupKey).total_changes += 1
        }
      })

      const rows = []
      groupSets.forEach((sets, groupKey) => {
        const row = rowMap.get(groupKey)

        rows.push({
          case_id: this.deviceLocationChangesGroupBy.includes("case_id") ? row.case_id : `${sets.cases.size} devices`,
          sender_organisation: this.deviceLocationChangesGroupBy.includes("sender_organisation")
            ? row.sender_organisation
            : `${sets.senders.size} senders`,
          receiving_organisation: this.deviceLocationChangesGroupBy.includes("receiving_organisation")
            ? row.receiving_organisation
            : `${sets.receivers.size} receivers`,
          vehicle_id: this.deviceLocationChangesGroupBy.includes("vehicle_id")
            ? row.vehicle_id
            : `${sets.vehicles.size} vehicles`,
          total_changes: row.total_changes,
        })
      })

      return rows
    },
  },
  watch: {
    currentTab() {
      this.loadActiveTab()
    },
    // Drop any selected tags that no longer exist in the current trips data,
    // otherwise a stale selection silently empties the report
    tripAssignmentsTagOptions(options) {
      const available = new Set(options.filter(option => option.value).map(option => option.value))

      this.tripAssignmentsTags = this.tripAssignmentsTags.filter(tag => available.has(tag))
    },
  },
  mounted() {
    this.loadActiveTab()
  },
  methods: {
    fetchData() {
      // Invalidate any cached fetches whose dates no longer match the inputs.
      // The active tab is loaded immediately; inactive tabs are loaded when
      // the user navigates to them.
      const newKey = this.currentDateKey
      Object.keys(this.fetchedDateKey).forEach(k => {
        if (this.fetchedDateKey[k] !== null && this.fetchedDateKey[k] !== newKey) {
          this.fetchedDateKey[k] = null
        }
      })

      this.loadActiveTab()
    },
    // The later of the device check-in and its last position report. Either one
    // means the device was still alive at that point, so the most recent of the
    // two is the best guess at when it was last online and working.
    lastOnlineMs(device) {
      const stamps = [device.status?.device_timestamp, device.status?.position_timestamp]
        .map(value => Number(value))
        .filter(value => Number.isFinite(value) && value > 0)

      return stamps.length ? Math.max(...stamps) * 1000 : null
    },
    formatOfflineDuration(totalMinutes) {
      if (!Number.isFinite(totalMinutes) || totalMinutes <= 0) {
        return "0m"
      }

      const days = Math.floor(totalMinutes / 1440)
      const hours = Math.floor((totalMinutes % 1440) / 60)
      const minutes = totalMinutes % 60

      const parts = []
      if (days > 0) parts.push(`${days}d`)
      if (hours > 0) parts.push(`${hours}h`)
      if (minutes > 0 || parts.length === 0) parts.push(`${minutes}m`)

      return parts.join(" ")
    },
    // This report's window comes from how long the devices have been offline
    // rather than the page's date range, so it caches against that instead
    loadProblemVehicles() {
      const window = this.problemVehiclesWindow
      if (this.fetchedDateKey.problemVehicles === window.key) return

      this.fetchedDateKey.problemVehicles = window.key
      this.problemVehiclesLoading = true

      this.fetchTripAssignments(window.startDate, window.endDate)
        .then(data => {
          this.problemVehicleTrips = data || []
        })
        .catch(error => {
          if (!axios.isCancel(error)) {
            console.error("Error fetching problem vehicle trips:", error)
            this.fetchedDateKey.problemVehicles = null
          }
          this.problemVehicleTrips = []
        })
        .finally(() => {
          this.problemVehiclesLoading = false
        })
    },
    loadActiveTab() {
      const key = this.activeReportKey
      if (!key) return

      if (key === "problemVehicles") {
        this.loadProblemVehicles()

        return
      }

      if (this.fetchedDateKey[key] === this.currentDateKey) return

      this.fetchedDateKey[key] = this.currentDateKey

      // Ignore time on start & end date
      const startDate = dayjs.tz(this.startDate, "Pacific/Auckland").format("YYYY-MM-DD 00:00:00")
      const endDate = dayjs.tz(this.endDate, "Pacific/Auckland").format("YYYY-MM-DD 23:59:59")

      switch (key) {
        case "offRoutes":
          this.offRoutesLoading = true
          this.fetchOffRoutes(startDate, endDate)
            .then(data => {
              this.offRoutes = data
            })
            .catch(error => {
              if (!axios.isCancel(error)) {
                console.error("Error fetching off routes:", error)
                this.fetchedDateKey.offRoutes = null
              }
              this.offRoutes = []
            })
            .finally(() => {
              this.offRoutesLoading = false
            })
          break

        case "networkUsage":
          this.networkUsageLoading = true
          this.fetchNetworkUsage(startDate, endDate)
            .then(data => {
              this.networkUsage = data
            })
            .catch(error => {
              if (!axios.isCancel(error)) {
                console.error("Error fetching network usage:", error)
                this.fetchedDateKey.networkUsage = null
              }
              this.networkUsage = []
            })
            .finally(() => {
              this.networkUsageLoading = false
            })
          break

        case "trips":
          this.tripsLoading = true
          this.fetchTripAssignments(startDate, endDate)
            .then(data => {
              this.trips = data
            })
            .catch(error => {
              if (!axios.isCancel(error)) {
                console.error("Error fetching trip assignments:", error)
                this.fetchedDateKey.trips = null
              }
              this.trips = []
            })
            .finally(() => {
              this.tripsLoading = false
            })
          break

        case "tripReports":
          this.tripReportsLoading = true
          this.fetchTripReports(startDate, endDate)
            .then(data => {
              this.tripReports = data
            })
            .catch(error => {
              if (!axios.isCancel(error)) {
                console.error("Error fetching trip reports:", error)
                this.fetchedDateKey.tripReports = null
              }
              this.tripReports = []
            })
            .finally(() => {
              this.tripReportsLoading = false
            })
          break

        case "deviceReboots":
          this.deviceRebootsLoading = true
          this.fetchDeviceReboots(startDate, endDate)
            .then(data => {
              this.deviceReboots = data || []
            })
            .catch(error => {
              if (!axios.isCancel(error)) {
                console.error("Error fetching device reboots:", error)
                this.fetchedDateKey.deviceReboots = null
              }
              this.deviceReboots = []
            })
            .finally(() => {
              this.deviceRebootsLoading = false
            })
          break

        case "deviceLocationChanges":
          this.deviceLocationChangesLoading = true
          this.fetchDeviceLocationChanges(startDate, endDate)
            .then(data => {
              this.deviceLocationChanges = data || []
            })
            .catch(error => {
              if (!axios.isCancel(error)) {
                console.error("Error fetching device location changes:", error)
                this.fetchedDateKey.deviceLocationChanges = null
              }
              this.deviceLocationChanges = []
            })
            .finally(() => {
              this.deviceLocationChangesLoading = false
            })
          break

        default:
          break
      }
    },
    async fetchOffRoutes(startDate, endDate) {
      this.offRoutesRequest.cancel("New fetch requested")
      this.offRoutesRequest = axios.CancelToken.source()

      return store.dispatch("getOffRoutesReport", {
        start_datetime: startDate,
        end_datetime: endDate,
        cancelToken: this.offRoutesRequest.token,
      })
    },
    async fetchNetworkUsage(startDate, endDate) {
      this.networkUsageRequest.cancel("New fetch requested")
      this.networkUsageRequest = axios.CancelToken.source()

      return store.dispatch("getNetworkUsageReport", {
        start_datetime: startDate,
        end_datetime: endDate,
        cancelToken: this.networkUsageRequest.token,
      })
    },
    fetchTripAssignments(startDate, endDate) {
      this.tripsRequest.cancel("New fetch requested")
      this.tripsRequest = axios.CancelToken.source()

      return store.dispatch("getTripAssignmentReport", {
        start_datetime: startDate,
        end_datetime: endDate,
        cancelToken: this.tripsRequest.token,
      })
    },
    fetchTripReports(startDate, endDate) {
      this.tripReportsRequest.cancel("New fetch requested")
      this.tripReportsRequest = axios.CancelToken.source()

      return store.dispatch("getDeviceEventsByType", {
        event_type: "trip_reports",
        start_datetime: startDate,
        end_datetime: endDate,
        cancelToken: this.tripReportsRequest.token,
      })
    },
    fetchDeviceReboots(startDate, endDate) {
      this.deviceRebootsRequest.cancel("New fetch requested")
      this.deviceRebootsRequest = axios.CancelToken.source()

      return store.dispatch("getDeviceEventsByType", {
        event_type: "reboots",
        start_datetime: startDate,
        end_datetime: endDate,
        cancelToken: this.deviceRebootsRequest.token,
      })
    },
    fetchDeviceLocationChanges(startDate, endDate) {
      this.deviceLocationChangesRequest.cancel("New fetch requested")
      this.deviceLocationChangesRequest = axios.CancelToken.source()

      return store.dispatch("getDeviceLocationChanges", {
        start_datetime: startDate,
        end_datetime: endDate,
        cancelToken: this.deviceLocationChangesRequest.token,
      })
    },
    customSort(items, sortBy, sortDesc) {
      const sortByField = sortBy[0] ?? ""
      const sortDescending = sortDesc[0] ?? false

      items.sort((a, b) => {
        let sortA = a[sortByField]
        let sortB = b[sortByField]

        // Special handling of field sorting when required
        switch (sortByField) {
          case "upload": {
            sortA = a.upload_bytes
            sortB = b.upload_bytes

            break
          }
          case "download": {
            sortA = a.download_bytes
            sortB = b.download_bytes

            break
          }
          case "total_usage": {
            sortA = a.total_bytes
            sortB = b.total_bytes

            break
          }
          case "stops_announced_percentage": {
            sortA = parseFloat(a.stops_announced_percentage)
            sortB = parseFloat(b.stops_announced_percentage)

            break
          }

          default:
            break
        }

        if (sortA > sortB) return 1
        if (sortA < sortB) return -1

        return 0
      })

      // Reverse order if header clicked again
      if (sortDescending) {
        items.reverse()
      }

      return items
    },
    getNetworkColour(totalBytes) {
      // dont apply colours unless we group by dates
      if (this.networkGroupBy && this.networkGroupBy.length) {
        return null
      }

      totalBytes = parseInt(totalBytes, 10)

      if (totalBytes > this.networkUsageAlert) {
        return "error"
      }
      if (totalBytes > this.networkUsageWarning) {
        return "warning"
      }

      return null
    },
    showNetworkColour() {
      if (this.networkGroupBy && this.networkGroupBy.length > 0) {
        return false
      }

      return true
    },
    prettyPrint(data) {
      return JSON.stringify(data, null, 4)
    },
    formatPercentage(value) {
      const formatter = new Intl.NumberFormat("en-US", {
        style: "percent",
        maximumFractionDigits: 2,
        minimumFractionDigits: 0,
      })

      return formatter.format(value)
    },
    formatRate(value, total) {
      return this.formatPercentage(total ? value / total : 0)
    },
    // Whether a day of trips ran after the vehicle's SSD was replaced. Vehicles
    // that were never tagged have nothing to be after, so they always count.
    isTripAfterNewSsd(item) {
      const newSsdDate = this.tripAssignmentsNewSsdDateMap.get(item.vehicle_id)

      if (!newSsdDate) {
        return true
      }

      return dayjs.tz(item.date, "Pacific/Auckland").format("YYYY-MM-DD") > newSsdDate
    },
    // Whether a trip belongs to the current tag selection: its vehicle carries
    // every selected tag, and where New SSD is one of them the trip also has to
    // postdate the swap, so the filtered totals match the tag breakdown.
    isTripInTagSelection(item, taggedVehicleIds) {
      if (taggedVehicleIds && !taggedVehicleIds.has(item.vehicle_id)) {
        return false
      }

      if (!this.tripAssignmentsSelectedTags.device.some(isNewSsdTag)) {
        return true
      }

      return this.isTripAfterNewSsd(item)
    },
    // A row's device tags. New SSD is dropped from rows whose trips all predate
    // the swap; every other tag applies to the whole reporting period.
    deviceTagsForTrips(vehicleId, latestTripDate) {
      const tags = this.tripAssignmentsDeviceTagsMap.get(vehicleId) || []
      const newSsdDate = this.tripAssignmentsNewSsdDateMap.get(vehicleId)

      if (!newSsdDate || latestTripDate > newSsdDate) {
        return tags
      }

      return tags.filter(tag => !isNewSsdTag(tag))
    },
    async openMapDialog(item) {
      this.mapDialog = true
      this.isMapLoading = true
      try {
        await this.showTripReportByEvent(item.event_id, item.vehicle_id)
      } catch (error) {
        console.error("Failed to load map data:", error)
      } finally {
        this.isMapLoading = false
      }
    },
    closeMapDialog() {
      this.mapDialog = false
      this.selectedTripDataByEventId = []
      this.selectedTripGpsData = []

      // Cancel any ongoing requests if they close it early
      this.eventsRequest.cancel("Dialog closed")
      this.eventsRequest = axios.CancelToken.source()
    },
    async fetchPositionsForSelectedDates(vehicleId, startDateTime, endDateTime) {
      // Cancel any existing request
      if (this.gpsRequest) {
        this.gpsRequest.cancel("New fetch requested")
      }
      this.gpsRequest = axios.CancelToken.source()
      const currentRequest = this.gpsRequest

      let combinedData = []

      // Create hourly intervals using dayjs
      let currentStart = dayjs.tz(startDateTime, "Pacific/Auckland")
      const finalEnd = dayjs.tz(endDateTime, "Pacific/Auckland")

      const dateTimes = []
      // Build an array of start times for each chunk
      while (currentStart.isBefore(finalEnd)) {
        dateTimes.push(currentStart)
        currentStart = currentStart.add(1, "hour")
      }

      // If start and end are exactly the same, ensure we at least do 1 fetch
      const total = dateTimes.length > 0 ? dateTimes.length : 1

      this.gpsProgress = {
        total,
        current: 1,
        percentage: 0,
        finished: false,
      }

      for (let i = 0; i < total; i += 1) {
        if (this.gpsRequest !== currentRequest) {
          console.log("Skipping abandoned GPS fetch...")
          continue
        }

        // Format the chunk start and end
        const chunkStart = dateTimes[i] ? dateTimes[i].format("YYYY-MM-DDTHH:mm:ss") : startDateTime
        let chunkEnd = dateTimes[i] ? dateTimes[i].add(1, "hour") : finalEnd

        // Don't let the chunk end exceed the actual final end time
        if (chunkEnd.isAfter(finalEnd)) {
          chunkEnd = finalEnd
        }

        try {
          const data = await store.dispatch("getPositions", {
            vehicle_id: vehicleId,
            start_datetime: chunkStart,
            end_datetime: chunkEnd.format("YYYY-MM-DDTHH:mm:ss"),
            cancelToken: this.gpsRequest.token,
          })

          if (data && data.error) {
            throw new Error(data.error)
          }

          if (data) {
            combinedData = [...combinedData, ...data]
          }
        } catch (e) {
          if (!axios.isCancel(e)) {
            console.error("Error fetching GPS chunk:", e)
          }
        }

        this.gpsProgress = {
          total,
          current: i + 1,
          percentage: ((i + 1) / total) * 100,
          finished: i + 1 === total,
        }
      }

      return combinedData
    },
    async showTripReportByEvent(eventId, vehicleId) {
      const cancelToken = this.eventsRequest.token

      const data = await store.dispatch(
        "getDeviceEventByEventId",
        {
          vehicle_id: vehicleId,
          event_type: "trip_reports",
          event_id: eventId,
        },
        cancelToken,
      )

      const updatedData = data?.map(item => {
        const stopAnnounceCounts = {}

        item.event_data.logs.forEach(log => {
          if (log.log_type === "stop_announced" && log.stop_id) {
            stopAnnounceCounts[log.stop_id] = (stopAnnounceCounts[log.stop_id] || 0) + 1
          }
        })

        const logs = item.event_data.logs.map(log => {
          const formattedLog = {
            ...log,
            timestamp: dayjs.unix(log.timestamp).tz("Pacific/Auckland").format("YYYY-MM-DD HH:mm:ss"),
          }

          if (log.log_type === "stop_announced" && log.stop_id) {
            formattedLog.stop_announcement_count = stopAnnounceCounts[log.stop_id]
          }

          return formattedLog
        })

        return {
          ...item,
          event_data: {
            ...item.event_data,
            logs,
            start_datetime: dayjs
              .unix(item.event_data.start_timestamp)
              .tz("Pacific/Auckland")
              .format("YYYY-MM-DD HH:mm"),
            end_datetime: dayjs.unix(item.event_data.end_timestamp).tz("Pacific/Auckland").format("YYYY-MM-DD HH:mm"),
          },
        }
      })

      if (updatedData.some(item => item.error)) {
        throw new Error("An error occurred in the data")
      }

      this.selectedTripDataByEventId = updatedData

      const gpsStartDateTime = updatedData[0].event_data.start_datetime
      const gpsEndDateTime = updatedData[0].event_data.end_datetime

      this.selectedTripGpsData = await this.fetchPositionsForSelectedDates(vehicleId, gpsStartDateTime, gpsEndDateTime)
    },
  },
}
</script>

<style scoped></style>
